import TablePagination from '@mui/material/TablePagination'

export default function RecruitmentPagination({ ...rest }) {
  return (
    <TablePagination
      {...rest}
      sx={{
        width: '100%',
      }}
      component="div"
      labelRowsPerPage="Show"
      SelectProps={{ sx: { borderRadius: 1 } }}
      showFirstButton
      showLastButton
      rowsPerPageOptions={[5, 10, 20, 50]}
    />
  )
}
